/*
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 *
 * Copyright: 2023 by Idemia Identity & Security USA LLC. All rights reserved.
 * License: In accordance  Idemia I&S USA LLC's license agreement.
 * Code Classification: GOVERNMENT
 *
 * Classification Person: Nadim Bakizada nadim.bakizada@us.idemia.com
 * Classification Reason: Software not specific to any U.S. Government Entity
 * Classification Date: 2023
 *
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 */
import { ProtectedLayout } from "components/layouts/ProtectedLayout";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  defer,
} from "react-router-dom";
import { AppLayout } from "./components/layouts/AppLayout";
import { AuthLayout } from "./components/layouts/AuthLayout";
import {
  AgencyManagement,
  ApplicantDetails,
  BatchPrinting,
  Login,
  RapBackSummary,
  RapbackMaintenance,
  RapbackPrenotifications,
  RapbackValidations,
  TransactionSummary,
  UserManagement,
  UserGuideViewer
} from "./pages";
import { DashboardPage } from "./pages/Dashboard/DashboardPage";
import { DashboardLandingRedirect } from "./components/Dashboard/DashboardLandingRedirect"
import AdminRouteGuard from "./components/AppBar/components/PermissionRouteGuard"
import PermissionRouteGuard from "./components/AppBar/components/PermissionRouteGuard";
import { pdfjs } from 'react-pdf';

const getUserData = async () => {
  await new Promise((resolve) => setTimeout(resolve, 3000));
  return new URLSearchParams(document.cookie).get("token");
};

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<AuthLayout />}
      loader={() => defer({ userPromise: getUserData() })}
    >
      <Route element={<AppLayout />}>
        <Route index element={<Login />} />
      </Route>
      <Route path="/app" element={<ProtectedLayout />}>
        <Route index element={<DashboardLandingRedirect />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="transaction-summary" element={<TransactionSummary />} />
        <Route path="agency-management" element={
          <PermissionRouteGuard requiredPermission="viewAgencies">
            <AgencyManagement />
          </PermissionRouteGuard>
        } />
        <Route path="rapback-summary" element={<RapBackSummary />} />
        <Route path="user-management" element={
          <PermissionRouteGuard requiredPermission="viewUserManagement">
            <UserManagement />
          </PermissionRouteGuard>
        } />
        {/* <Route path="permissions-settings" element={<PermissionsSettings />}/> */}
        <Route path="batch-printing" element={<BatchPrinting />} />
        <Route path="rapback-maintenance" element={<RapbackMaintenance />} />
        <Route path="rapback-prenotifications" element={<RapbackPrenotifications />} />
        <Route path="rapback-validations" element={<RapbackValidations />} />
        <Route
          path="applicant-details/:registrationId"
          element={<ApplicantDetails />}
        />
      </Route>
      <Route path="user-guide" element={<UserGuideViewer />} />
    </Route>
  )
);